@for (b2bProgramTypeItem of b2bProgramTypeList; track b2bProgramTypeItem.id) {
    <div class="form-check select-program-type-dialog-form-check">
        <input
            class="form-check-input"
            type="radio"
            name="b2bProgramType"
            [attr.checked]="b2bProgramType === b2bProgramTypeItem.id ? 'checked' : null"
            [attr.id]="'b2bProgramType_' + b2bProgramTypeItem.id"
            (change)="selectB2bProgramType(b2bProgramTypeItem.id)" />
        <label class="form-check-label select-program-type-dialog-form-check-label" [attr.for]="'b2bProgramType_' + b2bProgramTypeItem.id">
            {{ b2bProgramTypeItem.title | translate }}
        </label>
    </div>
}
<ui-dialog-actions>
    <ui-button [label]="'global.actions.confirm' | translate"
               [square]="true"
               (handlerClick)="confirmB2bProgramTypeSelect()" />
</ui-dialog-actions>
